<template>
  <div class="log">
    <div class="log-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="log-filter-value" v-model.trim="entityId" @keyup.enter.native="searchChange" placeholder="数据ID" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="log-filter-value" v-model.trim="userId" @keyup.enter.native="searchChange" placeholder="操作员" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="log-filter-value" placeholder="操作名称" v-model="actionName" filterable clearable size="small">
              <el-option
                v-for="item in adminActionNameEnum"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button class="log-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="log-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <basic-container>
      <avue-crud ref="crud"
                 :page="page"
                 :data="tableData"
                 :table-loading="tableLoading"
                 :option="tableOption"
                 @on-load="getList"
                 @current-change="currentChange"
                 @refresh-change="handleRefreshChange"
                 @size-change="sizeChange">
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import {fetchUserActionLogList, fetchActionUserList} from '@/api/admin/log'
import {tableOption, adminActionNameEnum} from '@/const/crud/admin/log'
import {mapGetters} from 'vuex'
import {validatenull, validatenum} from '@/util/validate'

export default {
  name: 'log',
  data() {
    return {
      tableData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10 // 每页显示多少条
      },
      tableLoading: false,
      tableOption: tableOption,
      adminActionNameEnum: adminActionNameEnum,
      entityId: '',
      userId: '',
      actionName: '',
    }
  },
  mounted: function () {
  },
  computed: {
    ...mapGetters(['permissions'])
  },
  methods: {
    async getList(page) {
      let params = {}
      if (!validatenull(this.entityId)) {
        if (validatenum(this.entityId, 2)) {
          this.$message({
            showClose: true,
            message: '数据 ID 只能输入数字',
            type: 'error',
          });
          return
        }
        params.entityId = this.entityId
      }
      if (!validatenull(this.actionName)) {
        params.actionName = this.actionName
      }
      if (!validatenull(this.userId)) {
        params.userId = this.userId
      }

      this.tableLoading = true
      const response = await this.requestWrapper(fetchUserActionLogList, Object.assign({
        current: page.currentPage,
        size: page.pageSize
      }, params))
      this.tableLoading = false
      if (!response || response.ok === false || !response.data) {
        this.$message({
          showClose: true,
          message: response.message || '获取数据失败',
          type: 'error',
        });
        return
      }
      this.tableData = response.data.records
      this.page.total = response.data.total
    },
    searchChange(form) {
      this.page.currentPage = 1
      this.getList(this.page)
    },
    handleRefreshChange() {
      this.getList(this.page)
    },
    searchReset() {
      this.entityId = ''
      this.actionName = ''
      this.userId = ''
      this.searchChange()
    },
    currentChange(val) {
      this.page.currentPage = val
    },
    sizeChange(val) {
      this.page.pageSize = val
    },
  }
}
</script>

<style lang="scss" scoped>
.log {
  .log-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    .log-filter-value {
      width: 96% !important;
    }
    .log-filter-search {
      float: right;
      margin-right: 8px;
    }
    .log-filter-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
}
</style>

